import { StoreManager } from '@ysfe/store'

import { AppModule } from './modules/app-module'
import { DownloadModule } from './modules/download-module'
import { ShareModule } from './modules/share-module'

export default class Store extends StoreManager {
    /** 应用配置 */
    app: AppModule = new AppModule()

    /** 下载能力相关 */
    download: DownloadModule = new DownloadModule()

    /** 分享能力相关 */
    share: ShareModule = new ShareModule()
}
